import { UpgradeStateEnum } from '@/enums/autarkyUpgrade';

// 保险数据
export interface InsuracneInformation {
  applyId: string;
  beginTime: string;
  createTime: string;
  endTime: string;
  id: number;
  idCard: string;
  isDelete: boolean;
  name: string;
  phone: string;
  policyInfo: string;
  policyNo: string;
  policyState: string;
  resultLog: string;
  supplier: string;
  updateTime: string;
  userId: string;
  companyLogo: string;
  companyName: string;
  detail: Dictionary<string>[];
  insuranceName: string;
  salesNumber: string;
}

export interface CreditApplyTaskType {
  /** 商品渠道id集合 */
  commodityList: number [],
  /** 商品渠道与模式集合 */
  commodityModelList: commodityModelItemType[],
  /** 申请类型，autarkySecond：自营B autarkyFirst：自营A */
  applyType?: string,
  /** 申请模式，serial：串行，parallel：并行 */
  applyMode?: string,
  /** 流量分发批次号 */
  dispatchBatchNo?: string,
  /** 是否被自营A圈选用户 */
  autarky?: boolean,
  /** 征信路由渠道 */
  creditRouteChannel?: string,
  /** 透传参数 */
  extra?: Record<string, unknown>,
}

export interface commodityModelItemType {
  commodityId: number;
  proApplyModel: string;
  /** 渠道是否异常 */
  abnormalProduct: boolean;
  /** 是否为跟贷渠道 */
  followLoan: boolean;
  /** 是否为战略轻资产产品 */
  strategyAsset?: boolean;
}

/** 半流程撞库场景 */
export enum dcCreditSceneEnum {
  /** 无渠道分发 */
  NO_CHANNEL_AVAILABLE = 'NO_CHANNEL_AVAILABLE',
  /** 纯半流程 */
  PURE_DC = 'PURE_DC',
}

/** 流量初筛分发类型 */
export enum PrefilterDispatchTypeEnum {
  /** 定向-自营8180渠道 */
  DIRECT_8180 = 'direct8180',
  /** 定向-轻资产渠道 */
  LIGHT_DISPATCH = 'lightDispatch',
}

/** 用户停留查看协议时长是否达标的情况分类 */
export enum UserStayStatusSceneEnum {
  /** 用户停留时长，已达标 */
  TIME_REACH = 'time_reach',
  /** 用户停留时长，不达标：中途离开 */
  MIDWAY_LEAVE = 'midway_leave',
}

export interface DcCreditApplyParams {
  commodityList: number[];
  scene: dcCreditSceneEnum;
  applyMode?: string;
  // 资料不完整标识
  incompleteInfo?: boolean;
}

/** 授信订单-审核状态 */
export enum CreditTaskStatusEnum {
  /** 审核中 */
  SUBMITTING = 'SUBMITTING',
  /** 审核通过 */
  SUCCEEDED = 'SUCCEEDED',
  /** 审核失败 */
  FAILED = 'FAILED',
}

/** 授信申请详情 */
export interface CreditTaskResultType {
  /** 审核状态 */
  taskStatus: CreditTaskStatusEnum;
  /** 授信申请成功总额度 */
  applySucceesAmount: number;
  /** 授信申请渠道id，以,分隔，如：8180,8117,8118 */
  commotdityIds: string;
  /** 是否需要ocr后置提现流程 */
  ocrAfterLoan: boolean;
}

/** 车抵贷准入判断接口返回 */
export interface CarLoanAdmissionResult {
  /** 车抵贷页面链接（返回url则表示准入成功） */
  url?: string;
}
